/*!
 *
 * mtcGoogleMaps.js - A jQuery plugin for google maps
 * Version : 0.5
 * Author(s) : Valdis Ceirans
 *
 * Docs: http://wiki.mtcmedia.co.uk/index.php?title=Jquery_Plugin_-_mtc_google_maps
 * Website: http://www.mtcmedia.co.uk
 *
 */

window.initGoogleMaps = function initGoogleMaps () {
    'use strict';

    var js_path = "/plugins/GoogleMaps/include/";

    $.getScript(js_path + "infobox.js", function (data, textStatus, jqxhr) {
        $.getScript(js_path + "cluster.js", function (data, textStatus, jqxhr) {
            $('.googleMap').each(function (i, elem) {
                $(elem).data('plugin_mtcGoogleMaps').init();

            });
        });
    });

    $('body').on('click', '.js_focusMarker', function (e) {

        var plugin, place, map;

        e.preventDefault();

        map = $('#map' + $(this).data('map-id'));

        plugin = map.data('plugin_mtcGoogleMaps');

        place = plugin.places[$(this).data('place-id')];

        plugin.google_map.panTo(place.marker.getPosition());

        plugin.google_map.setZoom(16);
    });

    $('body').on('click', '.js_dealershipInfo', function (e) {

        var plugin, place, map;

        e.preventDefault();

        map = $('#map' + $(this).data('map-id'));

        plugin = map.data('plugin_mtcGoogleMaps');

        place = plugin.places[$(this).data('place-id')];

        // open infobox
        google.maps.event.trigger(place.marker, 'click');

        plugin.google_map.panTo(place.marker.getPosition());

        plugin.google_map.setZoom(16);
    });

    $('body').on('click', '.js_mapDirections', function (e) {
        e.preventDefault();
    });
}

;(function ($, window, document, undefined) {

    // Create the defaults once
    var plugin_name = "mtcGoogleMaps",
        data_key = "plugin_" + plugin_name,
        defaults = {
            marker: {
                icon: null,
                width: null,
                height: null,
                origin_x: null,
                origin_y: null,
                anchor_x: null,
                anchor_y: null,
                type: null
            },
            info_box: {
                close_button_markup: '<button>x</button>',
                width: 200,
                offset_x: -100,
                offset_y: -50,
                align_bottom: true,
                close_on_click: true,
                disable_auto_pan: false,
                info_box_class: 'infobox'

            },
            search: {
                distance: 50,
                max_results: 3,
                no_results_markup: '<p>Sorry, no places nearby were found</p>',
                result_zoom: 8,
                search_results: '',
                search_form: '',
                autocomplete: false,
                get_directions: false,
                directions_element: $('#directionsPanel'),
                map_redesign: false
            },
            styles: null,
            cluster: false
        };

    $.fn[plugin_name] = function (options) {
        var load_called = $('body').hasClass('hasGMapsApi'),
            plugin_api_key;

        // Pop out the error message
        if (this.length === 0) {
            return this;
        }

        //  call init
        if (this.length > 0) {
            //load google js async
            if ( !load_called) {
                var script = document.createElement('script');
                plugin_api_key = $('body').data('maps-api-key');
                script.type = 'text/javascript';
                script.src = '//maps.googleapis.com/maps/api/js?key=' + plugin_api_key + '&libraries=places&callback=initGoogleMaps';
                document.body.appendChild(script);

                $('body').addClass('hasGMapsApi');
            }
            //for each of the elements call plugin
            return this.each(function (index, el) {
                var plugin, _name;
                plugin = $.data(this, data_key);
                if (typeof options === 'string') {
                    return plugin !== null ? typeof plugin[_name = options] === "function" ? plugin[_name]() : void 0 : void 0;
                } else if (!plugin) {
                    $(el).addClass('googleMap');
                    return $.data(this, data_key, new Plugin(el, options));
                }
            });

        }

    };

    //sort points by proximity
    function sortPointsByProximity (location, places, search_distance) {

        var points_sorted = [],
            index,
            marker_place,
            dif;

        for (index = 0; index < places.length; index++) {

            marker_place = places[index].marker.getPosition();
            dif =  PythagorasEquirectangular(location.lat(), location.lng(), marker_place.lat(), marker_place.lng());

            if (search_distance >= dif) {
                points_sorted.push({
                    dif: dif,
                    id: index
                });
            }
        }

        points_sorted.sort(compareByDif);
        return points_sorted;
    }

    //compare 2 distances
    function compareByDif (a,b) {
        if (a.dif < b.dif) {
            return -1;
        }
        if (a.dif > b.dif) {
            return 1;
        }
        return 0;
    }

    function getFirstKey (data) {
        for (elem in data ) {
            return elem;
        }
    }
    //calculate distance
    function PythagorasEquirectangular (lat1, lon1, lat2, lon2) {
        lat1 = Deg2Rad(lat1);
        lat2 = Deg2Rad(lat2);
        lon1 = Deg2Rad(lon1);
        lon2 = Deg2Rad(lon2);
        var R = 6371; // km
        var x = (lon2-lon1) * Math.cos( (lat1 + lat2) / 2);
        var y = (lat2-lat1);
        var d = Math.sqrt(x * x + y * y) * R;
        return d;
    }
    // Convert Degress to Radians
    function Deg2Rad (deg) {
        return deg * Math.PI / 180;
    }
    // calcualte the route between two points
    function calculateAndDisplayRoute(directionsService, directionsDisplay, location1, location2) {

        directionsService.route({
            origin: location1,
            destination: location2,
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.IMPERIAL

        }, function(response, status) {
            if (status === google.maps.DirectionsStatus.OK) {
                directionsDisplay.setDirections(response);
            } else {
                $('#directionsPanel').html('<p class="error">No directions found for this request.</p>');
            }
        });
    }
    // The actual plugin constructor
    function Plugin (elem, options) {
        this.element = elem;
        this.settings = $.extend( true, {}, defaults, options );
        this._defaults = defaults;
        this._name = plugin_name;
        this.map_id = 0;
        this.places = [];
        this.places_count = 0;
        this.google_map = null;
        this.info_box = null;
        this.markers = [];
        this.bounds = null;
        this.marker_cluster = [];
        this.map_mode = null;
        map_count = 0;
        geocoder = null;
    }

    Plugin.prototype = {
        //init funciton
        init : function () {
            var plugin = this,
                autocomplete;

            this.map_id = map_count;
            ++map_count;

            plugin.loadMaps();

            //stokist search
            if ($(plugin.settings.search.search_form).length > 0 && $(plugin.settings.search.search_results).length > 0) {

                $(plugin.settings.search.search_form + ' button').on('click', function (e) {
                    e.preventDefault();

                    if (plugin.settings.search.map_redesign === true) {

                        var location_field = $('#location_search'),
                            location_field_val = location_field.val(),
                            list_div = 'list',
                            map_div = 'map',
                            error_html = $('<div class="errorWrap"><i class="fa fa-exclamation"></i><span>Please enter your location or postcode</span></div>');

                        if (location_field_val !== '') {
                            location_field.parent().removeClass('inputError showError');
                            $('.errorWrap').remove();
                            $('.gridWithBordersWrap[data-active-div="' + list_div + '"]').fadeOut(function () {
                                $('.findUsWrapRedesign[data-active-div="' + map_div + '"]').fadeIn();
                                plugin.findAddress();
                            });
                        } else {
                            if ($('.errorWrap').length < 1) {
                                location_field.parent().addClass('inputError showError');
                                error_html.appendTo(location_field.parent());
                                $('.findUsWrapRedesign[data-active-div="' + map_div + '"]').fadeOut(function () {
                                    $('.gridWithBordersWrap[data-active-div="' + list_div + '"]').fadeIn();
                                });
                            }
                        }
                    } else {
                        plugin.findAddress();
                    }
                });

                $(plugin.settings.search.search_form + ' select').on('change', function (e) {
                    plugin.findType();
                });

                autocomplete = new google.maps.places.Autocomplete($(plugin.settings.search.search_form + ' input').get(0));

                if (plugin.settings.search.autocomplete === true) {
                    autocomplete.bindTo('bounds', plugin.google_map);

                    google.maps.event.addListener(autocomplete, 'place_changed', function () {
                         plugin.findAddress();
                    });
                }
            }

            if ($(plugin.settings.search.search_form).length > 0 && plugin.settings.search.get_directions === true) {

                autocomplete = new google.maps.places.Autocomplete($(plugin.settings.search.search_form + ' input').get(0));

                $('body').on('submit', '.addressSearch', function (e) {

                    e.preventDefault();

                    // reset the map and directions
                    plugin.settings.search.directions_element.html('');

                    plugin.loadMaps();

                    var directionsDisplay = new google.maps.DirectionsRenderer,
                        directionsService = new google.maps.DirectionsService,
                        location1 = $(plugin.settings.search.search_form + ' input').val(),
                        location2;

                    directionsDisplay.setMap(plugin.google_map);

                    if($(window).width() > 670) {
                        directionsDisplay.setPanel(document.getElementById('directionsPanel'));
                    } else {
                        directionsDisplay.setPanel(document.getElementById('directionsPanelMobile'));
                    }

                    location2 = plugin.places[0].marker.getPosition().lat() + ", " + plugin.places[0].marker.getPosition().lng();

                    calculateAndDisplayRoute(directionsService, directionsDisplay, location1, location2);

                    if($(window).width() > 670) {
                        $('.js_printDirections.desktop').css({
                            'display': 'inline-block'
                        });
                    } else {
                        $('.js_printDirections.mobile').css({
                            'display': 'inline-block'
                        });
                    }

                    if (plugin.settings.search.map_redesign === true) {
                        $('html, body').animate({
                            scrollTop: $('.directionsWrap').offset().top
                        }, 'slow');
                    } else {
                        $('html, body').animate({scrollTop: 250}, 'slow');
                    }
                });
            }
        },

        loadMaps : function () {

            google.maps.visualRefresh = true;

            var mapEl = $(this.element),
                mapOptions,
                infobox_options,
                myLatlng,
                zoom = 14,
                noUi = mapEl.data('no-ui'),
                plugin = this,
                place,
                mapId;

            plugin.bounds = new google.maps.LatLngBounds(),

            geocoder = new google.maps.Geocoder();
            //for each map
            mapEl.each(function (index, map) {
                place = {};

                place.map_id = plugin.id;

                // one or multiple coordinates
                if ($(map).data('coords')) {
                    plugin.map_mode = 'single';
                } else if ($(map).data('coords-array')) {
                    plugin.map_mode = 'multiple';
                } else if ($(map).data('json-array')) {
                    plugin.map_mode = 'json';
                }

                mapId = map_count-1;

                $(map).attr('id', 'map' + mapId);

                //set map options
                if (plugin.map_mode === 'single') {

                    place.coords = $(map).data('coords').split(',');

                    if (typeof($(map).data('marker-icon')) !== 'undefined') {
                        place.marker_icon = $(map).data('marker-icon');
                    }
                    if (typeof($(map).data('title')) !== 'undefined') {
                        place.title = $(map).data('title');
                    }
                    if (typeof($(map).data('description')) !== 'undefined') {
                        place.description = $(map).data('description');
                    }

                    plugin.places[plugin.places_count] = jQuery.extend({}, place);
                    ++plugin.places_count;

                } else if (plugin.map_mode === 'multiple') {
                    var coordsArrayHolder = $($(this).data('coords-array')),
                        coordsArray = coordsArrayHolder.find('[data-coords]');

                    if (coordsArray.length > 0) {
                        coordsArray.each(function (i, el) {
                            place.coords = $(this).data('coords').split(',');

                            place.marker_icon = $(this).data('marker-icon');

                            place.type = $(this).data('type');

                            if (typeof($(map).data('title-selector')) !== 'undefined') {
                                place.title = $(this).find($(map).data('title-selector')).html();
                                var link = $('<a/>', {
                                    href: "#",
                                    "data-map-id": map_count-1,
                                    "data-place-id": i,
                                    class : 'js_focusMarker'
                                });

                                $(this).find($(map).data('title-selector')).wrapInner(link);
                            }

                            if (typeof($(map).data('description-selector')) !== 'undefined') {
                                place.description = $(this).find($(map).data('description-selector')).html();
                            }

                            if (typeof($(map).data('link-selector')) !== 'undefined') {
                                place.link = $(this).find($(map).data('link-selector')).html();
                            }

                            //$(this).data('marker-id',plugin.places.length);
                            plugin.places[plugin.places_count] = jQuery.extend({}, place);
                             ++plugin.places_count;
                        });
                    }

                } else if (plugin.map_mode === 'json') {
                    var arr = window[$(this).data('json-array')];
                    $.each(arr, function (i, el) {
                        place.coords = el.coords.split(',');

                        if (typeof(el.marker_icon) !== 'undefined') {
                             place.marker_icon = el.marker_icon;
                        }

                        if (typeof(el.title) === 'string') {
                            place.title = el.title;
                        }

                        if (typeof(el.description) === 'string') {
                            place.description = el.description;
                        }

                        plugin.places[plugin.places_count] = jQuery.extend({}, place);
                        ++plugin.places_count;
                    });
                }

                if (typeof($(map).data('zoom')) !== "undefined") {
                    zoom  = $(map).data('zoom');
                }

                if (typeof($(map).data('scrollwheel')) !== "undefined") {
                    scrollwheel  = $(map).data('scrollwheel');
                } else {
                    scrollwheel = true;
                }

                mapOptions = {
                    zoom: zoom,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    disableDefaultUI: noUi,
                    center: new google.maps.LatLng(plugin.places[0].coords[0], plugin.places[0].coords[1]),
                    scrollwheel: false
                };

                plugin.google_map = new google.maps.Map(map, mapOptions);

                if (typeof(plugin.settings.styles) !== 'undefined') {
                    plugin.google_map.setOptions({
                        styles: plugin.settings.styles
                    });
                }

                infobox_options = {
                    alignBottom : plugin.settings.info_box.align_bottom,
                    content:  'loading..',
                    disableAutoPan: plugin.settings.disable_auto_pan,
                    maxWidth: 0,
                    pixelOffset: new google.maps.Size(plugin.settings.info_box.offset_x, plugin.settings.info_box.offset_y),
                    zIndex: null,
                    boxStyle: {
                        width: plugin.settings.info_box.width + "px"
                    },
                    closeBoxMargin: "0",
                    closeButtonMarkup: plugin.settings.info_box.close_button_markup,
                    infoBoxClearance: new google.maps.Size(1, 1),
                    isHidden: false,
                    pane: "floatPane",
                    enableEventPropagation: false,
                    boxClass: plugin.settings.info_box.info_box_class
                };

                plugin.info_box = new InfoBox(infobox_options);

                plugin.markers = [];
                plugin.markers.length = 0;

                $.each(plugin.places, function (i, value) {

                    var marker_icon, marker_image = null;

                    if (typeof(value.marker_icon) !== 'undefined') {
                        marker_icon = value.marker_icon;
                    } else if (typeof(plugin.settings.marker.icon) !== 'undefined') {
                        marker_icon = plugin.settings.marker.icon;
                    }

                    if (typeof(marker_icon) !== 'undefined' && plugin.settings.marker.width !== null) {
                        marker_image = {
                            url: marker_icon,
                            size: new google.maps.Size(plugin.settings.marker.width, plugin.settings.marker.height),
                            origin: new google.maps.Point(plugin.settings.marker.origin_x, plugin.settings.marker.origin_y),
                            anchor: new google.maps.Point(plugin.settings.marker.anchor_x, plugin.settings.marker.anchor_y)
                        };
                    } else if (typeof(marker_icon) !== 'undefined') {
                        marker_image = marker_icon;
                    }

                    if (typeof(value.type) !== 'undefined') {
                        type = value.type;
                    } else {
                        type = ''
                    }

                    myLatlng = new google.maps.LatLng(value.coords[0], value.coords[1]);

                    value.marker = new google.maps.Marker({
                        position: myLatlng,
                        map: plugin.google_map,
                        icon: marker_image,
                        type: type
                    });

                    plugin.markers.push(value.marker);

                    value.marker.setMap(plugin.google_map);
                    plugin.bounds.extend(value.marker.getPosition());

                    //add title and description
                    if (typeof(value.description) !== 'undefined' || typeof(value.title) !== 'undefined') {
                        value.marker.addListener('click', function () {
                            var titleMarkup = "",
                                descriptionMarkup = "";

                            if (typeof(value.description) !== 'undefined') {
                                descriptionMarkup = value.description;
                            }

                            if (typeof(value.title) !== 'undefined') {
                                titleMarkup = '<h3>' + value.title + '</h3>';
                            }

                            plugin.info_box.setContent('<div class="info_boxContent">'+ titleMarkup + descriptionMarkup + '</div>');
                            plugin.info_box.open(plugin.google_map, value.marker);
                        });
                    }
                });

                // Add a marker clusterer to manage the markers.

                if (plugin.settings.cluster === true) {
                    plugin.addClusters();
                }

                plugin.closeInfoBox();

                plugin.fitBounds();

                google.maps.event.addDomListener(window, "resize", function () {
                    var center = plugin.google_map.getCenter();
                    google.maps.event.trigger(plugin.google_map, "resize");
                    plugin.google_map.setCenter(center);
                });

            });
        },

        findAddress  : function () {
            var plugin = this,
                address = $(plugin.settings.search.search_form + ' input').val(),
                results_place = $(plugin.settings.search.search_results),
                i,
                place,
                html;

            $(".js_clearSearch").addClass("active");

            $(plugin.settings.search.search_form + ' select').val('');

            geocoder.geocode( { address: address}, function (results, status) {

                if (status === google.maps.GeocoderStatus.OK) {

                    var sorted_points = sortPointsByProximity(results[0].geometry.location, plugin.places, plugin.settings.search.distance),
                        nearest_point_key = getFirstKey(sorted_points);
                    //reset results
                    results_place.html("");

                    $.each(plugin.places, function () {

                        this.marker.setVisible(false);

                    });

                    //if results then show

                    if (sorted_points.length > 0) {
                        plugin.bounds = new google.maps.LatLngBounds();
                        plugin.bounds.extend(new google.maps.LatLng(results[0].geometry.location.lat(),results[0].geometry.location.lng()));

                        for (var i in sorted_points) {

                            if (i >= plugin.settings.search.max_results) {
                                return false;
                            }

                            place = plugin.places[sorted_points[i].id];

                            if (plugin.settings.search.map_redesign === true) {
                                html = '<li><h5 class="title"><a href="" data-map-id="'+ plugin.map_id + '" data-place-id="'+ sorted_points[i].id + '" class="js_focusMarker">' + place.title + '</a></h5>' + '<div class="description">' + place.description + '</div><a href="#" data-map-id="'+ plugin.map_id + '" data-place-id="'+ sorted_points[i].id + '" class="dealershipInfo js_dealershipInfo"><img src="/sites/petervardy/images/svgs/info-circle-light.svg" alt="Dealership Information"></a><div class="selectorLink">' + place.link + '</div></li>';
                            } else {
                                html = '<li><h5 class="title"><a href="" data-map-id="'+ plugin.map_id + '" data-place-id="'+ sorted_points[i].id + '" class="js_focusMarker">' + place.title + '</a></h5>' + '<div class="description">' + place.description + '</div><div class="selectorLink">' + place.link + '</div></li>';
                            }

                            plugin.bounds.extend(new google.maps.LatLng(place.marker.getPosition().lat(), place.marker.getPosition().lng()));

                            plugin.google_map.fitBounds(plugin.bounds);

                            results_place.append(html);

                            place.marker.setVisible(true);
                        }
                    //if no results
                    } else {
                        results_place.append(plugin.settings.search.no_results_markup);
                    }

                    if (sorted_points.length === 1) {
                        plugin.google_map.setCenter(new google.maps.LatLng(place.marker.getPosition().lat(), place.marker.getPosition().lng()));
                        plugin.google_map.setZoom(plugin.settings.search.result_zoom);
                    }

                    $('#locationAmount').html(sorted_points.length);

                    if (sorted_points.length > 1) {
                        $('#all').text("all ");
                    } else {
                        $('#all').text("");
                    }
                }
            });

            return false;
        },

        findType : function () {
            var plugin = this,
                type = $(plugin.settings.search.search_form + ' select').val(),
                results_place = $(plugin.settings.search.search_results),
                places_by_type = [],
                place;

            $(".js_clearSearch").addClass("active");

            plugin.bounds = new google.maps.LatLngBounds();

            $(plugin.settings.search.search_form + ' input').val('');

            results_place.html("");

            if(type !== '' && plugin.places.length > 0) {

                plugin.markers = [];

                if (plugin.settings.cluster === true) {
                    plugin.marker_cluster.clearMarkers();
                }

                $.each(plugin.places, function (i, value) {

                    if(this.title.includes(type)) {

                        this.marker.setVisible(true);
                        places_by_type.push(
                            this
                        );

                        html = '<li><h5 class="title"><a href="" data-map-id="'+ plugin.map_id + '" data-place-id="'+ this.id + '" class="js_focusMarker">' + this.title + '</a></h5>' + '<div class="description">' + this.description + '</div><div class="selectorLink">' + this.link + '</div></li>';

                        plugin.bounds.extend(new google.maps.LatLng(this.marker.getPosition().lat(), this.marker.getPosition().lng()));

                        plugin.google_map.fitBounds(plugin.bounds);

                        results_place.append(html);

                        plugin.markers.push(value.marker);

                    } else {
                        this.marker.setVisible(false);
                    }
                });

                if (plugin.settings.cluster === true) {
                    plugin.addClusters();
                }

                // if only one found then set zoom level
                if (places_by_type.length === 1) {
                    plugin.google_map.setZoom(plugin.settings.search.result_zoom);
                }

                // if no results show message
                if (places_by_type.length <= 0) {
                    results_place.append(plugin.settings.search.no_results_markup);
                }

                $('#locationAmount').html(places_by_type.length);

                // if (sorted_points.length > 1) {
                //     $('#all').text("all ");
                // } else {
                //     $('#all').text("");
                // }

            } else {
                $.each(plugin.places, function () {

                    html = '<li><h5 class="title"><a href="" data-map-id="'+ plugin.map_id + '" data-place-id="'+ this.id + '" class="js_focusMarker">' + this.title + '</a></h5>' + '<div class="description">' + this.description + '</div><div class="selectorLink">' + this.link + '</div></li>';

                    results_place.append(html);

                    $('#locationAmount').html(plugin.places.length);

                    // if (sorted_points.length > 1) {
                    //     $('#all').text("all ");
                    // } else {
                    //     $('#all').text("");
                    // }
                });

                this.loadMaps();
            }

            return false;
        },

        closeInfoBox: function() {
            var plugin = this;
            if (plugin.settings.info_box.close_on_click === true) {
                google.maps.event.addListener(plugin.google_map, 'click', function () {
                    plugin.info_box.close();
                });
            }
        },

        fitBounds: function() {
            var plugin = this;
            if ((plugin.map_mode === 'multiple' || plugin.map_mode === 'json') && plugin.places.length > 1 ) {
                plugin.google_map.fitBounds(plugin.bounds);
                plugin.google_map.panToBounds(plugin.bounds);
            }
        },

        addClusters: function() {
            var plugin = this;

            plugin.marker_cluster = new MarkerClusterer(plugin.google_map, plugin.markers, {
                imagePath: '/sites/petervardy/images/icons/m'
            });
        }
    }


}(jQuery, window, document));

$(document).ready(function() {
    const clearSearch = $(".js_clearSearch");

    if (clearSearch.length > 0) {
        $('body').on('click', '.js_clearSearch', function() {
            $(".stokistSearch select").val("").change();
            $(".stokistSearch input").val("");

            clearSearch.removeClass("active");
        });
    }
})